import * as XLSX from "xlsx";

export type readXlsxFileProps = {
  Reader?: any;
  Converter?: any;
  sheetPage?: number;
  header?: number;
  file: any;
};

export type writeXlsxFileProps = {
  data: (string | number)[][];
  fileName?: string;
  fileExtension?: string;
  sheetName?: string;
  arrToSheet?: (v: (string | number)[][]) => any;
  createWorkBook?: (v: void) => any;
  appendSheetInBook?: (v: any, s: any, nme: string) => any;
  writeFile?: (v: any, nme: string) => any;
};

/**
 * readXlsxFile
 */

export const readXlsxFile = ({
  Reader = XLSX.read,
  Converter = XLSX.utils.sheet_to_json,
  sheetPage = 0,
  header = 0,
  file,
}: readXlsxFileProps): Promise<unknown[]> =>
  new Promise((resolve, reject) => {
    const fileReader = new FileReader();

    fileReader.onload = (e) => {
      const data = e.target.result;
      const readedData = Reader(data, { type: "binary" });
      const wsname = readedData.SheetNames[sheetPage];
      const ws = readedData.Sheets[wsname];

      const dataParse = Converter(ws, { header });

      resolve(dataParse);
    };

    fileReader.onerror = (error) => {
      reject(error);
    };

    fileReader.readAsBinaryString(file);
  });

/**
 * writeXlsxFile
 */

export const writeXlsxFile = ({
  data,
  fileName = "excel",
  fileExtension = "xlsx",
  sheetName = "Sheet1",
  arrToSheet = XLSX.utils.aoa_to_sheet,
  createWorkBook = XLSX.utils.book_new,
  appendSheetInBook = XLSX.utils.book_append_sheet,
  writeFile = XLSX.writeFile,
}: writeXlsxFileProps): void => {
  const worksheet = arrToSheet(data);
  const newWorkbook = createWorkBook();
  appendSheetInBook(newWorkbook, worksheet, sheetName);
  writeFile(newWorkbook, fileName + "." + fileExtension);
};
